import React from 'react';
// eslint-disable-next-line import/no-unresolved
import { TypographyProps } from '@altibox/design-system-component-lib/dist/components/typography/types';

export enum LinkTheme {
    LIGHT,
    DARK,
}

export interface StyledLinkProps {
    $focusTheme?: LinkTheme;
}

export type LinkProps = StyledLinkProps &
    React.AnchorHTMLAttributes<HTMLAnchorElement> &
    Omit<TypographyProps, 'component'>;
